module.exports = __webpack_public_path__ + "img/bank-download-transactions.4ca76386.svg";